import api from '../../services/api';

const findTodayTargetBySellerUserId = async (sellerUserId) =>
    api.get({ service: `financial/sales-metrics/${sellerUserId}` });

export default {
    findTodayTargetBySellerUserId
}